import React, { useEffect, useRef } from 'react';
import { Root } from './styles';
import Image from '../Image/Image';
import { useInView } from 'react-intersection-observer';
import Icon from '../Icon/Icon';
import { Button, BUTTON_TYPES } from '../Button/Button';
import { useTitle } from '../primitives/teaser/teaserHooks';
import { cx } from '@linaria/core';
import { Typo } from '../primitives/Typo';
export function Banner({ description, longDescription, mediumDescription, shortDescription, image, title, longTitle, mediumTitle, shortTitle, onClose, onVisible, button, isLoadingEagerly = false, isVisible = true, isTitleVisible = true, }) {
    /** Variables */
    const [rootRef, inView] = useInView({ threshold: 0.5, triggerOnce: true });
    const contentRef = useRef(null);
    const teaserTitle = useTitle(contentRef, longTitle, shortTitle, mediumTitle, title);
    const teaserDescription = useTitle(contentRef, longDescription, shortDescription, mediumDescription, description);
    useEffect(() => {
        if (isVisible && inView && onVisible) {
            onVisible();
        }
    }, [inView, onVisible]);
    if (!isVisible) {
        return null;
    }
    /** JSX */
    return (React.createElement("div", { className: cx(Root.base), ref: rootRef },
        onClose && (React.createElement(Button, { type: BUTTON_TYPES.TEXT, text: "Banner ausblenden", isIconOnly: true, iconLeft: React.createElement(Icon, { name: "remove" }), onClick: onClose })),
        image && React.createElement(Image, { ...image, isLoadingEagerly: isLoadingEagerly }),
        React.createElement("div", { ref: contentRef },
            teaserTitle && isTitleVisible && React.createElement("h2", { className: cx(Typo.base, Typo.heading04) }, teaserTitle),
            teaserDescription && React.createElement("p", { className: cx(Typo.base, Typo.body02) }, teaserDescription),
            button && React.createElement(Button, { ...button }))));
}
export default React.memo(Banner);
